// Detects the runtime environment from window.location.hostname and exposes a
// matching emoji + colour so the browser tab is instantly distinguishable. Stops
// "accidentally clicked the prod tab" mistakes when localhost / QA / prod are
// open side-by-side under the same favicon.

const ENVS = {
  LOCAL: { key: 'LOCAL', emoji: '🔴', color: '#dc2626', letter: 'L' },
  QA:    { key: 'QA',    emoji: '🟡', color: '#d97706', letter: 'Q' },
  PROD:  { key: 'PROD',  emoji: '🟢', color: '#16a07a', letter: 'P' },
}

export function detectEnv (hostname = window.location.hostname) {
  const h = (hostname || '').toLowerCase()
  if (!h || h === 'localhost' || h === '127.0.0.1' || h.endsWith('.local')) {
    return ENVS.LOCAL
  }
  if (
    h.startsWith('uat.') || h.startsWith('qa.') || h.includes('-qa.') || h.startsWith('staging.')
    || h.includes('uat') || h.includes('.qa.')
    // Netlify preview/UAT deploys live on *.netlify.app; the real prod
    // frontend has its own domain, so any netlify host is non-prod.
    || h.endsWith('.netlify.app')
  ) {
    return ENVS.QA
  }
  return ENVS.PROD
}

function buildFaviconDataUrl (env) {
  // Rounded-square SVG with the env letter centred — visible at 16×16 in a tab.
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <rect width="64" height="64" rx="14" fill="${env.color}"/>
  <text x="50%" y="54%" text-anchor="middle" dominant-baseline="middle"
        font-family="-apple-system,Segoe UI,Roboto,sans-serif"
        font-weight="800" font-size="40" fill="#ffffff">${env.letter}</text>
</svg>`
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
}

export function applyEnvFavicon (env = detectEnv()) {
  if (env.key === 'PROD') return
  const href = buildFaviconDataUrl(env)
  const selectors = ['link[rel="icon"]', 'link[rel="apple-touch-icon"]', 'link[rel="shortcut icon"]']
  selectors.forEach((sel) => {
    document.querySelectorAll(sel).forEach((node) => node.parentNode.removeChild(node))
  })
  const link = document.createElement('link')
  link.rel = 'icon'
  link.type = 'image/svg+xml'
  link.href = href
  document.head.appendChild(link)
}

export function decorateTitle (rawTitle, env = detectEnv()) {
  if (env.key === 'PROD') return rawTitle
  return `[${env.key}] ${rawTitle}`
}

// The DB-connection indicator only matters on non-production frontends: local
// and UAT can be (accidentally) pointed at either database, so devs need to see
// which one they're touching. The real prod frontend always talks to prod, so
// the marker would just be noise there — hide it.
export function shouldShowDbIndicator (env = detectEnv()) {
  return env.key !== 'PROD'
}
